var rich_content_viewer_default = {
  "fontElementMap": "vamy8",
  "wrapper": "TQzjn",
  "pluginContainerMobile": "E0NaQ",
  "viewer": "ULONp",
  "android": "_7chAG",
  "rootedTraversedContent": "VWU4s",
  "atomic": "Kg-zu",
  "toolbar": "HK5vd",
  "block": "_8w-E8"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
